export default __webpack_public_path__ + "40a09c03ce2ff1babab688c531d81090.svg";